<div class="m-portlet__head-caption">
    <div class="m-portlet__head-title">
        <div class="m-portlet__head-text">
            <!-- Dogodek -->
            <i ngbTooltip="Dogodek" class="la la-sticky-note"></i>
            <span class="m--font-bold">
                {{ data?.eventDate }}
                ,
                {{ data?.title }}
            </span>
        </div>
    </div>
</div>
<div class="m-portlet__head-tools">
    <ul class="m-portlet__nav">
        <li class="m-portlet__nav-item">
            <span *ngIf="data?.availabilityStatus == availabilityStatus.NOT_CHECKED" class="m-badge m-badge--warning m-badge--wide">
                Spremembe niso shranjene
            </span>
            <a
                *ngIf="data?.availabilityStatus == availabilityStatus.NOT_CHECKED"
                (click)="updateNote()"
                ngbTooltip="Shrani dogodek"
                container="body"
                class="m-portlet__nav-link m-portlet__nav-link--icon text-decoration-none mf-cursor-pointer"
            >
                <i class="la la-edit"></i>
            </a>

            <div
                x-placement="bottom-end"
                style="position: absolute; transform: translate3d(-64px, 70px, 0px); top: 0px; left: 0px; will-change: transform"
                class="dropdown-menu dropdown-menu-right"
            >
                <a (click)="removeNote()" class="dropdown-item cursor m--font-danger mf-cursor-pointer">Izbriši</a>
            </div>
            <a
                ngbTooltip="Akcije"
                style="cursor: pointer"
                data-toggle="dropdown"
                role="button"
                aria-haspopup="true"
                aria-expanded="false"
                container="body"
                class="m-portlet__nav-link m-portlet__nav-link--icon"
            >
                <i class="la la-ellipsis-v"></i>
            </a>

            <a
                (click)="toggleExpand()"
                ngbTooltip="Prikaži/skrij podrobnosti"
                container="body"
                class="m-portlet__nav-link m-portlet__nav-link--icon text-decoration-none mf-cursor-pointer"
            >
                <i class="la" [ngClass]="data.isDetailsOpend ? 'la-angle-up' : 'la-angle-down'"></i>
            </a>
        </li>
    </ul>
</div>
